/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Typography } from "@mui/material";
import {
  DiffValue,
  NumericDiff,
} from "components/search/input/DifferencePanel/common";

interface MassDiffProps {
  previous: number | null | undefined;
  updated: number | null | undefined;
  massUnit: string;
  format: (value: number) => string;
}

export const MassDiff = ({
  previous,
  updated,
  massUnit,
  format,
}: MassDiffProps) => {
  const previousValue = previous ?? null;
  const updatedValue = updated ?? null;
  if (previousValue === null && updatedValue === null) {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }
  if (previousValue === null && updatedValue !== null) {
    return (
      <DiffValue color="success.main">
        + {format(updatedValue)}
        {massUnit}
      </DiffValue>
    );
  }
  if (updatedValue === null && previousValue !== null) {
    return (
      <DiffValue color="error.main">
        - {format(previousValue)}
        {massUnit}
      </DiffValue>
    );
  }
  if (previousValue === updatedValue) {
    return (
      <Typography variant="body2">
        {format(updatedValue!)}
        {massUnit}
      </Typography>
    );
  }
  return (
    <NumericDiff
      previous={previousValue!}
      updated={updatedValue!}
      suffix={massUnit}
      format={format}
    />
  );
};
